<app-header></app-header>

<app-content>
  <router-outlet></router-outlet>
</app-content>

<app-footer></app-footer>
